import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Subject, Subscription, interval, Observable } from "rxjs";
import { environment } from "../environments/environment";
import { WorkSpaceDto, NotebookDto, AssistantDto, ThreadDto, StudiaPlanDto, JobDto, Theme, AvatarImage, Me, LibraryCategory, Activity, Account, UserDto, WizardConfigDto, FolderDto, TabDto, ContentDto, ContentPositionDto, MessageDto, EvaluationDto, StudiaPlanTaskDto, CommunityGroupDto, LibraryBookDto, LibraryReviewDto, LibrarySubcategory, LibraryUserResumeDto, MemberGroupDto, MessageGroupDto, UserPaymentDto } from "../models/models";
import { AuthService } from "./auth.service";
import oboe from "oboe";

@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  private _notificationWorkspace$ = new Subject<WorkSpaceDto>();
  workspaceSelected$ = this._notificationWorkspace$.asObservable();

  private _notificationNotebook$ = new Subject<NotebookDto>();
  bookSelected$ = this._notificationNotebook$.asObservable();

  private _notificationJobsQueue$ = new Subject<JobDto[]>();
  jobsQueue$ = this._notificationJobsQueue$.asObservable();

  private notifications: any[]=[];
  private workspaces: WorkSpaceDto[] = [];
  private subscribeBooks: NotebookDto[]=[];
  // private assistants: AssistantDto[] = [];
  // private threads: ThreadDto[] = [];
  private groups: CommunityGroupDto[]=[];
  private studiaPlans: StudiaPlanDto[]=[];
  private pendingJobs: JobDto[]=[];
  jobsSubscription!: Subscription;
  private pendingJobsFirstCheck:boolean = false;

  private notebooks: any[] = [];
  private tabs: any[] = [];

  colorsAvailable: Theme[] = [
    {id:"1", name:"tab-color-one", color:"One", hex:"#1563b0", hexlight:"#76b4f1", hexlight2:"#c9e4ff"},
    {id:"2", name:"tab-color-two", color:"Two", hex:"#aa9108", hexlight:"#e6cd42", hexlight2:"#fff5bb"},
    {id:"3", name:"tab-color-three", color:"Three", hex:"#d95d09", hexlight:"#f49555", hexlight2:"#ffe6d6"},
    {id:"4", name:"tab-color-four", color:"Four", hex:"#66095a", hexlight:"#A1118E", hexlight2:"#ffd4fa"},
    {id:"5", name:"tab-color-five", color:"Five", hex:"#00976a", hexlight:"#08C089", hexlight2:"#d3fff2"},
    {id:"6", name:"tab-color-six", color:"Six", hex:"#ca0d55", hexlight:"#EC1265", hexlight2:"#ffd7e6"}
  ];
  
  avatarsAvailable: AvatarImage[]=[
    {id:1, url:"https://scwcloud.blob.core.windows.net/public/studia_assets/avatar01.png"},
    {id:2, url:"https://scwcloud.blob.core.windows.net/public/studia_assets/avatar02.png"},
    {id:3, url:"https://scwcloud.blob.core.windows.net/public/studia_assets/avatar03.png"},
    {id:4,url:"https://scwcloud.blob.core.windows.net/public/studia_assets/avatar04.png"},
    {id:5,url:"https://scwcloud.blob.core.windows.net/public/studia_assets/avatar05.png"},
    {id:6,url:"https://scwcloud.blob.core.windows.net/public/studia_assets/avatar06.png"},
    {id:7,url:"https://scwcloud.blob.core.windows.net/public/studia_assets/avatar07.png"},
    {id:8,url:"https://scwcloud.blob.core.windows.net/public/studia_assets/avatar08.png"},
    {id:9,url:"https://scwcloud.blob.core.windows.net/public/studia_assets/avatar09.png"},
    {id:10,url:"https://scwcloud.blob.core.windows.net/public/studia_assets/avatar10.png"},
    {id:11,url:"https://scwcloud.blob.core.windows.net/public/studia_assets/avatar11.png"},
    {id:12,url:"https://scwcloud.blob.core.windows.net/public/studia_assets/avatar12.png"},
    {id:13,url:"https://scwcloud.blob.core.windows.net/public/studia_assets/avatar13.png"},
    {id:14,url:"https://scwcloud.blob.core.windows.net/public/studia_assets/avatar14.png"}
  ];

  avatarsAssistantAvailable: AvatarImage[]=[
    {id:1, url:"https://scwcloud.blob.core.windows.net/public/studia_assets/avatar-bot01.png"},
    {id:2, url:"https://scwcloud.blob.core.windows.net/public/studia_assets/avatar-bot02.png"},
    {id:3, url:"https://scwcloud.blob.core.windows.net/public/studia_assets/avatar-bot03.png"}
  ];

  private currentWorkspace: any = null;
  private currentNotebook: any = null;
  private currentTab: any = null;

  userInitialized: boolean = false;
  private menuExpanded: boolean = false;

  constructor(private http: HttpClient, private auth: AuthService) {       
  }

  public startPendingJobsObserver()
  {
    //JOB WORKER
    //TODO: CHECK KEEP ALIVE FOR REFRESH
    //emit value in sequence every 10 second
    const source = interval(30000);
    this.jobsSubscription = source.subscribe(val => {
        
        if((this.pendingJobs!=null && this.pendingJobs.length>0) || !this.pendingJobsFirstCheck)
        {
            this.getPendingJobs().subscribe((_jobs:JobDto[])=>{
              
              var finishedJobs = this.pendingJobs.filter(function(item){
                return _jobs.find(job=>item.id==job.id)==null;
              });
              
              if(finishedJobs!=null && finishedJobs.length>0)
              {
                this._notificationJobsQueue$.next(finishedJobs);
              }

              this.pendingJobs = _jobs
              //this.pendingJobsFirstCheck = true;
            });
        }
    });
  }

  public getColors():Theme[]
  {
    return this.colorsAvailable;
  }

  public getAvatars():AvatarImage[]
  {
    return this.avatarsAvailable;
  }

  public getAssistantAvatars():AvatarImage[]
  {
    return this.avatarsAssistantAvailable;
  }
  
  public getColor(id:string):Theme[]
  {
    return this.colorsAvailable.filter(c=>c.id==id);
  }

  public getColorByColor(color:string):Theme[]
  {
    return this.colorsAvailable.filter(c=>c.color==color);
  }

  public getColorHexlight2ByHex(color:string):string
  {
    return this.colorsAvailable.find(c=>c.hexlight==color)?.hexlight2??"";
  }

  // public getStreamingData(message: string, list: any[]): Observable<any> {      
  //   const headers = { 'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJudXJpaWlpaWlpbmt5IiwianRpIjoiNmYyZjU3MTMtYTM0OC00NDFlLTg3MjYtMDI1MTIxNDk5NDVmIiwiaWF0IjoxNzIyNTExNjk2LCJnaXZlbl9uYW1lIjoibnVyaWlpaWlpaW5reSIsImZhbWlseV9uYW1lIjoiTlVSSUlJSUlJSU5LWSIsImVtYWlsIjoiYWlydW4yNjA5QGdtYWlsLmNvbSIsInVzZXJJZCI6IjA5NzA0MWE0LWI1NzktNDQwMS0wYzYwLTA4ZGM4MjJjZTdiZCIsImFjY291bnQiOiJhaXJ1bjI2MDlAZ21haWwuY29tIiwibmFtZSI6Im51cmlpaWlpaWlua3kiLCJyb2xlIjpbInN1cGVyYWRtaW4iLCJBTEwiXSwibmJmIjoxNzIyNTExNjk2LCJleHAiOjE3MjI1MTg4OTZ9.4DvgxTotPIVqYfVHQ8rZse22j-_Bs15Dh2BaoFWGJHQ' }
  //   return new Observable<any>((observer) => {
  //     const oboeService = oboe({
  //         url: `${environment.netCoreApiUrl}Studia/Chat/${message}`,
  //         method: 'GET',
  //         cached: false, 
  //         headers: headers
  //     });
  //     oboeService.node('!', (data) => { 
  //       console.log("NODE", data);
  //       if(data!=undefined && data.Message=="#ENDSTREAM#")
  //         observer.complete();
  //       else
  //         observer.next(data)
  //     });          
  // });
  // }

  public addThreadMessage(message: any): Observable<any> {
    //  return this.http.post<MessageDto>(`${environment.netCoreApiUrl}Studia/AddMessage`, message);
    const user = JSON.parse(localStorage.getItem('nenomed-user')!);
      const headers = { 'Authorization': `Bearer ${user.AUTH_TOKEN}`}
    return new Observable<any>((observer) => {
      const oboeService = oboe({
          url: `${environment.nenomedApiUrl}api/IA/RunPrompt`,
          method: 'POST',
          cached: false, 
          headers: headers,body :message
      });
      oboeService.node('!', (data) => { 
        console.log("NODE", data);
        if(data!=undefined && (data.Message=="#ENDSTREAM#" || data.Message=="#NOCREDITS#"))
        {
          if(data.Message=="#NOCREDITS#")
          {
            observer.next(data);
          }
          observer.complete();
        }
        else
          observer.next(data)
      });          
  });
  }

  public getConsume(): Observable<any> {
    return this.http.get<any>(`${environment.netCoreApiUrl}Profile/Consume`);
  }

  public getProvinces(): Observable<any> {
    return this.http.get<any>(`${environment.netCoreApiUrl}Profile/Provinces`);
  }

  public getLocalities(): Observable<any> {
    return this.http.get<any>(`${environment.netCoreApiUrl}Profile/Localities`);
  }

  // public getMe(): Observable<any> {
  //   return this.http.get<any>(`http://localhost:50875/Kernel/GetMyCustomer`);
  // }

  public getMe(): Observable<any> {
    return this.http.get<any>(`${environment.nenomedCloudUrl}Kernel/MyUser`);
  }
  
  public checkDevice(device): Observable<any> {
    return this.http.post<any>(`${environment.nenomedApiUrl}api/Account/ValidateDevice`, device);
  }

  public getActivity(workspaceId: string): Observable<Activity> {
    return this.http.get<Activity>(`${environment.netCoreApiUrl}Studia/GetActivity/${workspaceId}`);
  }

  public getAccountInfo(): Observable<Account> {
    return this.http.get<Account>(`${environment.netCoreApiUrl}Profile/GetAccountInfo`);
  }

  public updateAccountInfo(account: Account): Observable<Account> {
    return this.http.post<Account>(`${environment.netCoreApiUrl}Profile/UpdateAccountInfo`, account);
  }

  public updateAccountPlan(account: Account): Observable<Account> {
    return this.http.post<Account>(`${environment.netCoreApiUrl}Profile/UpdateAccountPlan`, account);
  }

  public cancelAccountPlan(account: Account): Observable<Account> {
    const accountObj= {accountId: account.id};
    return this.http.post<Account>(`${environment.netCoreApiUrl}Profile/CancelAccountPlan`, accountObj);
  }

  public getProfile(): Observable<UserDto> {
    return this.http.get<UserDto>(`${environment.netCoreApiUrl}Profile/GetProfile`);
  }

  public updateProfile(profile: UserDto): Observable<UserDto> {
    return this.http.post<UserDto>(`${environment.netCoreApiUrl}Profile/UpdateProfile`, profile);
  }

  public updateProfileWizard(profile: WizardConfigDto):Observable<UserDto>{
    return this.http.post<UserDto>(`${environment.netCoreApiUrl}Profile/UpdateProfileWizard`, profile);
  }

  

  public getSecureFile(fileId: string): Observable<any> {
    return this.http.get<any>(`${environment.netCoreApiUrl}File/GetSecureFile/${fileId}`);
  }

  public getFolders(workspaceId: string): Observable<any> {
    return this.http.get<any>(`${environment.netCoreApiUrl}Studia/GetFolders/${workspaceId}`);
  }

  public addUpdateFolder(folder: FolderDto): Observable<FolderDto> {
    return this.http.post<FolderDto>(`${environment.netCoreApiUrl}Studia/AddFolder`, folder);
  }

  public linkFileAssistant(workspaceId:string, fileId:string):Observable<any>{    
    const obj = {workspaceId : workspaceId, fileId: fileId};
    return this.http.post<any>(`${environment.netCoreApiUrl}Studia/LinkFileAssistant`, obj);
  }

  public removeLinkFileAssistant(workspaceId:string, fileId:string):Observable<boolean>{      
    const obj = {workspaceId : workspaceId, fileId: fileId};
    return this.http.post<boolean>(`${environment.netCoreApiUrl}Studia/RemoveLinkFileAssistant`, obj);
  }

  public removeMultipleLinkFileAssistant(workspaceId:string, filesId:string[]):Observable<boolean>{      
    const obj = {workspaceId : workspaceId, filesId: filesId};
    return this.http.post<boolean>(`${environment.netCoreApiUrl}Studia/RemoveMultiplesLinkFileAssistant`, obj);
  }
  
  public getFoldersBook(workspaceId: string, bookId: string): Observable<any> {
    return this.http.get<any>(`${environment.netCoreApiUrl}Studia/GetFoldersBook/${workspaceId}/${bookId}`);
  }

  public getFiles(folderId: string, workspaceId: string): Observable<any> {
    return this.http.get<any>(`${environment.netCoreApiUrl}Studia/GetFiles/${folderId}/${workspaceId}`);
  }

  public getFilesForContent(folderId: string): Observable<any> {
    return this.http.get<any>(`${environment.netCoreApiUrl}Studia/GetFilesForContent/${folderId}`);
  }

  public getFilesForAssistant(folderId: string, workspaceId: string): Observable<any> {
    return this.http.get<any>(`${environment.netCoreApiUrl}Studia/GetFilesFor/${folderId}/${workspaceId}/assistant`);
  }

  public getFilesForOpen(folderId: string, workspaceId: string): Observable<any> {
    return this.http.get<any>(`${environment.netCoreApiUrl}Studia/GetFilesFor/${folderId}/${workspaceId}/opendoc`);
  }

  public getFilesForVision(folderId: string, workspaceId: string): Observable<any> {
    return this.http.get<any>(`${environment.netCoreApiUrl}Studia/GetFilesFor/${folderId}/${workspaceId}/vision`);
  }
  
  public getExtractionFiles(fileId: string): Observable<any> {
    return this.http.get<any>(`${environment.netCoreApiUrl}Studia/GetExtractionFiles/${fileId}`);
  }

  public getFilesAttachToAssistant(assitantId: string): Observable<any> {
    return this.http.get<any>(`${environment.netCoreApiUrl}Studia/GetFilesAttachToAssistant/${assitantId}`);
  }
  

  public getContentForGeneration(bookId: string): Observable<any> {
    return this.http.get<any>(`${environment.netCoreApiUrl}Content/GetContentForGeneration/${bookId}`);
  }
  
  public createCardFromExtraction(extraction: any): Observable<any> {
    return this.http.post<any>(`${environment.netCoreApiUrl}Content/CreateCardFromExtraction`, extraction);
  }

  public setActiveWorkspace(workspaceId: string):Observable<boolean>{
    return this.http.post<boolean>(`${environment.netCoreApiUrl}Content/ActiveWorkspace/` + workspaceId,null );
  }

  public setActiveBook(workspaceId: string, bookId: string):Observable<boolean>{
    return this.http.post<boolean>(`${environment.netCoreApiUrl}Content/ActiveBook/` + workspaceId + `/`+ bookId, null);
  }

  public getWorkspaces(): Observable<WorkSpaceDto[]> {
    return this.http.get<WorkSpaceDto[]>(`${environment.netCoreApiUrl}Workspaces`);
  }

  public addWorkspaces(workspace: WorkSpaceDto): Observable<WorkSpaceDto> {
    return this.http.post<WorkSpaceDto>(`${environment.netCoreApiUrl}Content/AddWorkspace`, workspace);
  }

  public getBooks():Observable<NotebookDto[]>{
    return this.http.get<NotebookDto[]>(`${environment.netCoreApiUrl}Books`);
  }

  public addBook(book: NotebookDto): Observable<NotebookDto> {
    return this.http.post<NotebookDto>(`${environment.netCoreApiUrl}Content/AddBook`, book);
  }

  public addTab(tab: TabDto): Observable<TabDto> {
    return this.http.post<TabDto>(`${environment.netCoreApiUrl}Content/AddTab`, tab);
  }

  public deleteTab(id:string): Observable<boolean> {
    return this.http.delete<boolean>(`${environment.netCoreApiUrl}Content/DeleteTab/${id}`);
  }

  public deleteBook(id:string): Observable<boolean> {
    return this.http.delete<boolean>(`${environment.netCoreApiUrl}Content/DeleteBook/${id}`);
  }

  public deleteFile(file:any): Observable<boolean> {
    return this.http.post<boolean>(`${environment.netCoreApiUrl}Studia/DeleteFile`, file);
  }

  public deleteFiles(files:any[]): Observable<boolean> {
    return this.http.post<boolean>(`${environment.netCoreApiUrl}Studia/DeleteFiles`, files);
  }

  public fileShare(files:any[]): Observable<boolean> {
    return this.http.post<boolean>(`${environment.netCoreApiUrl}Share/Send`, files);
  }

  public addContent(content: ContentDto): Observable<ContentDto> {
    return this.http.post<ContentDto>(`${environment.netCoreApiUrl}Content/AddContent`, content);
  }

  public addLinkFile(content: ContentDto): Observable<ContentDto> {
    return this.http.post<ContentDto>(`${environment.netCoreApiUrl}Content/AddLinkFile`, content);
  }
  
  public deleteContent(id: string): Observable<boolean> {
    return this.http.delete<boolean>(`${environment.netCoreApiUrl}Content/DeleteContent/${id}`);
  }
  
  public addAssistant(assistant: AssistantDto): Observable<AssistantDto> {
    return this.http.post<AssistantDto>(`${environment.netCoreApiUrl}Studia/AddAssistant`, assistant);
  }

  public addThread(thread: ThreadDto): Observable<ThreadDto> {
    return this.http.post<ThreadDto>(`${environment.netCoreApiUrl}Studia/AddThread`, thread);
  }

  public addJob(job: JobDto): Observable<ContentDto> {
    return this.http.post<ContentDto>(`${environment.netCoreApiUrl}Studia/CreateJob`, job);
  }

  public getJobs(tabId: string):Observable<JobDto[]>{
    return this.http.get<JobDto[]>(`${environment.netCoreApiUrl}Studia/GetJobs/${tabId}`);
  }

  public getPendingJobs():Observable<JobDto[]>{
    return this.http.get<JobDto[]>(`${environment.netCoreApiUrl}Studia/GetPendingJobs`);
  }

  public getContentTab(tabId: string):Observable<ContentDto[]>{
    return this.http.get<ContentDto[]>(`${environment.netCoreApiUrl}Content/GetContentTab/${tabId}`);
  }
  
  public getSharedBookContent(bookId: string):Observable<TabDto[]>{
    return this.http.get<TabDto[]>(`${environment.netCoreApiUrl}Content/GetSharedBookContent/${bookId}`);
  }

  
  public getFoldersBookShared(workspaceId: string, bookId: string): Observable<any> {
    return this.http.get<any>(`${environment.netCoreApiUrl}Studia/GetFoldersBookShared/${workspaceId}/${bookId}`);
  }

  public updateContentPositions(positions: ContentPositionDto[]): Observable<boolean> {
    return this.http.post<boolean>(`${environment.netCoreApiUrl}Content/UpdateContentPosition`, positions);
  }

  public addStudiaPlan(plan: StudiaPlanDto): Observable<StudiaPlanDto> {
    return this.http.post<StudiaPlanDto>(`${environment.netCoreApiUrl}Plan/CreateStudiaPlan`, plan);
  }

  public getStudiaPlans(workspaceId: string):Observable<StudiaPlanDto[]>{
    return this.http.get<StudiaPlanDto[]>(`${environment.netCoreApiUrl}Plan/GetStudiaPlans/${workspaceId}`);
  }

  public getStudiaPlan(id: string):Observable<StudiaPlanDto>{
    return this.http.get<StudiaPlanDto>(`${environment.netCoreApiUrl}Plan/GetStudiaPlan/${id}`);
  }

  // public addThreadMessage(message: MessageDto): Observable<MessageDto> {
  //   return this.http.post<MessageDto>(`${environment.netCoreApiUrl}Studia/AddMessage`, message);
  // }

  public addEvaluationResponse(message: MessageDto): Observable<MessageDto> {
    return this.http.post<MessageDto>(`${environment.netCoreApiUrl}Studia/AddEvaluationResponse`, message);
  }

  public addEvaluation(evaluation: EvaluationDto): Observable<EvaluationDto> {
    return this.http.post<EvaluationDto>(`${environment.netCoreApiUrl}Studia/AddEvaluation`, evaluation);
  }

  public getMessages(threadId: string):Observable<MessageDto[]>{
    return this.http.get<MessageDto[]>(`${environment.netCoreApiUrl}Studia/GetMessages/${threadId}`);
  }

  public getSecureUrl(url: any):Observable<any>{
    return this.http.post<any>(`${environment.netCoreApiUrl}Content/SecureUrl`, {url: url});
  }

  public getMindMap(fileId: string):Observable<any[]>{
    return this.http.get<any[]>(`${environment.netCoreApiUrl}Content/GetMindMap/${fileId}`);
  }

  public getGeneration(fileId: string):Observable<any[]>{
    return this.http.get<any[]>(`${environment.netCoreApiUrl}Content/GetGeneration/${fileId}`);
  }

  public getStudiaPlanTaskByContent(contentId: string):Observable<any>{
    return this.http.get<any>(`${environment.netCoreApiUrl}Plan/GetStudiaPlanTaskByContent/${contentId}`);
  }

  public updateStudiaPlanTask(task: StudiaPlanTaskDto): Observable<StudiaPlanTaskDto> {
    return this.http.post<StudiaPlanTaskDto>(`${environment.netCoreApiUrl}Plan/UpdateStudiaPlanTask`, task);
  }

  public updateAssistantActiveThread(thread: any): Observable<boolean> {
    return this.http.post<boolean>(`${environment.netCoreApiUrl}Studia/UpdateAssistantActiveThread`, thread);
  }
  
  public createCommunityGroup(group:CommunityGroupDto):Observable<CommunityGroupDto>{
    return this.http.post<CommunityGroupDto>(`${environment.netCoreApiUrl}Community/CreateGroup`, group);
  }

  public addMessageGroup(message:MessageGroupDto):Observable<MessageGroupDto>{
    return this.http.post<MessageGroupDto>(`${environment.netCoreApiUrl}Community/AddMessageGroup`, message);
  }
  
  public getGroups():Observable<CommunityGroupDto[]>{
    return this.http.get<CommunityGroupDto[]>(`${environment.netCoreApiUrl}Community/GetGroups`);
  }

  public getMessagesGroup(groupId:string):Observable<MessageGroupDto[]>{
    return this.http.get<MessageGroupDto[]>(`${environment.netCoreApiUrl}Community/GetMessagesGroup/${groupId}`);
  }
  
  public getMembersGroup(groupId:string):Observable<MemberGroupDto[]>{
    return this.http.get<MemberGroupDto[]>(`${environment.netCoreApiUrl}Community/GetMembersGroup/${groupId}`);
  }

  public getLibraryCategories(): Observable<LibraryCategory[]> {
    return this.http.get<LibraryCategory[]>(`${environment.netCoreApiUrl}Library/GetCategories`);
  }

  public getLibrarySubcategories(): Observable<LibrarySubcategory[]> {
    return this.http.get<LibrarySubcategory[]>(`${environment.netCoreApiUrl}Library/GetSubcategories`);
  }

  public addBookToLibrary(library:LibraryBookDto):Observable<LibraryBookDto>{
    return this.http.post<LibraryBookDto>(`${environment.netCoreApiUrl}Library/AddBookToLibrary`, library);
  }

  public addReviewBookLibrary(review:LibraryReviewDto):Observable<LibraryReviewDto>{
    return this.http.post<LibraryReviewDto>(`${environment.netCoreApiUrl}Library/AddReviewToLibrary`, review);
  }

  public getLibraryBooks(): Observable<LibraryBookDto[]> {
    return this.http.get<LibraryBookDto[]>(`${environment.netCoreApiUrl}Library/GetLibraryBooks`);
  }

  public getLibraryBooksByUser(ownerId: string): Observable<LibraryBookDto[]> {
    return this.http.get<LibraryBookDto[]>(`${environment.netCoreApiUrl}Library/GetLibraryBooksByUser/${ownerId}`);
  }

  
  public getLibraryBookByBookId(id:string): Observable<LibraryBookDto> {
    return this.http.get<LibraryBookDto>(`${environment.netCoreApiUrl}Library/GetByBookId/${id}`);
  }

  public getLibraryBookById(id:string): Observable<LibraryBookDto> {
    return this.http.get<LibraryBookDto>(`${environment.netCoreApiUrl}Library/GetLibraryBookById/${id}`);
  }

  public getLibraryBooksByCategory(id:string, page:number, rows:number): Observable<LibraryBookDto[]> {
    const config = {page: page, rows: rows};
    return this.http.post<LibraryBookDto[]>(`${environment.netCoreApiUrl}Library/GetLibraryBooksByCategory/${id}`, config);
  }

  public getLibraryUsers(id:string, page:number, rows:number): Observable<LibraryUserResumeDto[]> {
    const config = {page: page, rows: rows};
    return this.http.post<LibraryUserResumeDto[]>(`${environment.netCoreApiUrl}Library/GetLibraryUsers/${id}`, config);
  }
  
  public getLibraryBookReviews(id:string): Observable<LibraryReviewDto[]> {      
    return this.http.get<LibraryReviewDto[]>(`${environment.netCoreApiUrl}Library/GetLibraryBookReviews/${id}`);
  }
  
  public subscribeUserToBook(libraryBookId:string): Observable<boolean> {
    const subscription = {libraryBookId: libraryBookId, createDt: new Date, userId: null};
    return this.http.post<boolean>(`${environment.netCoreApiUrl}Library/SubscribeUserToBook`, subscription);
  }  
  
  public unsubscribeUserToBook(libraryBookId:string): Observable<boolean> {
    const subscription = {libraryBookId: libraryBookId, createDt: new Date, userId: null};
    return this.http.post<boolean>(`${environment.netCoreApiUrl}Library/UnsubscribeUserToBook`, subscription);
  }   

  public getSubscribeBooks(): Observable<NotebookDto[]> {      
    return this.http.get<NotebookDto[]>(`${environment.netCoreApiUrl}Library/GetSubscribeBooks/`);
  }
  

  public analyseImage(message:string, image:string): Observable<any> {
    const _message = {userMessage:message, imageBase64:image};
    return this.http.post<any>(`${environment.netCoreApiUrl}Studia/AnalyseImage`,  _message);
  }

  public getPendingFriendships(): Observable<UserDto[]> {      
    return this.http.get<UserDto[]>(`${environment.netCoreApiUrl}Profile/GetPendingFriendships`);
  }
  
  public addFriendRequest(email: string, username: string): Observable<any> {
    const _request = {receiverEmail:email, receiverUserName: username};
    return this.http.post<any>(`${environment.netCoreApiUrl}Profile/AddFriendRequest`,  _request);
  }

  public getReceiveFriendRequests(): Observable<any> {      
    return this.http.get<any>(`${environment.netCoreApiUrl}Profile/GetReceiveFriendRequests`);
  }

  public registerPaymentItem(payment: UserPaymentDto): Observable<UserPaymentDto> {     
    return this.http.post<UserPaymentDto>(`${environment.netCoreApiUrl}Profile/RegisterPaymentItem`,  payment);
  }

  public getSendFriendRequests(): Observable<any> {      
    return this.http.get<any>(`${environment.netCoreApiUrl}Profile/GetSendFriendRequests`);
  }
  
  public getFriendships(): Observable<any> {      
    return this.http.get<any>(`${environment.netCoreApiUrl}Profile/GetFriendships`);
  }
  

  public addFriendship(requestId: string): Observable<any> {
    const _friend = {requestId:requestId};
    return this.http.post<any>(`${environment.netCoreApiUrl}Profile/AddFriendship`,  _friend);
  }

  public cancelFriendRequest(requestId: string): Observable<any> {
    const _friend = {requestId:requestId};
    return this.http.post<any>(`${environment.netCoreApiUrl}Profile/CancelFriendRequest`,  _friend);
  }

  getMenuState():boolean{
    return this.menuExpanded;
  }

  setMenuState(state:boolean)
  {
    this.menuExpanded = state;
  }

  setCurrentNotebook(notebook:NotebookDto)
  {
    this.setActiveBook(notebook.workspaceId!, notebook.id).subscribe();

    this.getCurrentWorkspace().books.forEach(b=>b.active=0);
    const current = this.getCurrentWorkspace().books.find(b=>b.id==notebook.id);
    if(current!=undefined && current!=null)
    {  
      current.active=1;
      this._notificationNotebook$.next(current)  
    }  
  }

  private currentSubscribeNotebook!: NotebookDto;
  setCurrentSubscribeBook(_current:NotebookDto)
  {
    this.currentSubscribeNotebook = _current; 
  }

  getCurrentSubscribeBook()
  {
    return this.currentSubscribeNotebook;
  }

  getCurrentNotebook():NotebookDto
  {
    const defaultBk = this.getCurrentWorkspace().books[0];
    const bk= this.getCurrentWorkspace().books.find(b=>b.active==1);
    return bk!=null?bk:defaultBk;
  }

  getCurrentNotebooks():NotebookDto[]
  {
    const arr: NotebookDto[]=[{id:'', description:'', tabs: []}];
    return (this.getCurrentWorkspace()?.books!=undefined)? this.getCurrentWorkspace()?.books : arr;
  }

  getCurrentWorkspace():WorkSpaceDto    {

    const defaultWs = this.workspaces[0];
    const ws = this.workspaces.find(w=>w.active==1);
    return ws!=null?ws:defaultWs;
  }
  
  
  getCurrentWorkspaces():WorkSpaceDto[]
  {
    return this.workspaces;
  }

  getCurrentSubscribeBooks():NotebookDto[]
  {
    return this.subscribeBooks;
  }

  loadCurrentWorkspaces(workspaces:WorkSpaceDto[])
  {
    console.log(workspaces);
    this.workspaces = workspaces;
  }

  loadSubscribeBooks(subscribeBooks:NotebookDto[])
  {
    this.subscribeBooks = subscribeBooks;
  }

  loadStudiaPlans(_studiaPlans:StudiaPlanDto[])
  {
    this.hasPlans = _studiaPlans.filter(s=>s.workspaceId==this.getCurrentWorkspace().id).length>0;
    this.studiaPlans = _studiaPlans;
  }

  getCurrentStudiaPlans():StudiaPlanDto[]
  {
    return this.studiaPlans.filter(s=>s.workspaceId==this.getCurrentWorkspace().id);
  }

  loadGroups(groups: CommunityGroupDto[])
  {
    this.groups = groups;
  }

  loadNotifications(notifications:any[])
  {
    this.notifications = notifications;
  }

  addNotification(notification:any)
  {
    var not:any = {};
    not.message = notification;
    not.read = false;      
    this.notifications.push(not);
  }

  getNotifications()
  {
    return this.notifications.filter(n=>n.read==false);
  }

  notificationsMarkRead()
  {
    this.notifications.forEach(n=>n.read=true);
  }

  getAssistants():AssistantDto[]
  {
    return this.getCurrentWorkspace().assistants??[];
  }

  getThreadsWorkspace():ThreadDto[]
  {
    return this.getCurrentWorkspace().threads??[];
  }

  getWorkspacesStorageSize()
  {
    var size=0;
    this.getCurrentWorkspaces().forEach((ws:WorkSpaceDto)=>{
      size+=ws.sizeInBytes??0;
    });
    return size;
  }

  activeAssistantThread():ThreadDto
  {      
    const _assistant = this.getAssistants()[0];
    return this.getThreadsWorkspace().find(t=>t.id==_assistant.activeThreadId) ?? this.getThreadsWorkspace()[0];      
  }

  getThreadsBook():ThreadDto[]
  {
    if(this.getCurrentWorkspace().threads!=undefined && this.getCurrentWorkspace().threads!=null)
      return this.getCurrentWorkspace().threads!.filter(a=>a.bookId==this.getCurrentNotebook().id);
    
    return [];
  }

  getCurrentGroups():CommunityGroupDto[]
  {
    return this.groups;
  }

  hasPlans: boolean = false;

  hasPlansCurrentWorkspace():boolean
  {
    return this.hasPlans;
  }

  setCurrentWorkspace(workspace: WorkSpaceDto)
  {      
    this.setActiveWorkspace(workspace.id).subscribe();
    this.workspaces.forEach(w=>w.active=0);
    const current = this.workspaces.find(w=>w.id==workspace.id);
    if(current!=undefined && current!=null)
    {  
      current.active=1;
      this.hasPlans = this.studiaPlans.filter(s=>s.workspaceId==workspace.id).length>0;              
      this._notificationWorkspace$.next(current)  
    }  
  }

  // get notificationWorkspace$(): Observable<WorkSpaceDto> {
  //   return this._notificationWorkspace$.asObservable()  
  // }    

  Init() {

    this.tabs = [];
    return new Promise<void>((resolve, reject) => {
        console.log("AppInitService.init() called");
        ////do your initialisation stuff here  
        setTimeout(() => {
            console.log('AppInitService Finished');
            this.currentWorkspace = this.workspaces[0];
            this.currentNotebook = this.workspaces[0]?.books[0];
            this.currentTab = this.currentNotebook?.tabs[0];
            this.userInitialized = true;
            resolve();
        }, 100);

    });
  }

  saveWorkspace(workspace:WorkSpaceDto, edit: boolean):Promise<WorkSpaceDto>
  {

    const _id:string = edit?workspace.id:"00000000-0000-0000-0000-000000000000";

    return new Promise<WorkSpaceDto>((resolve, reject) => {

      this.addWorkspaces({
        userId: this.auth.meData?.studiaUserId,
        id:  _id,  
        description: workspace.description,        
        name: workspace.name,
        books:[],
        createDt: workspace.createDt,
        updateDt: workspace.updateDt,
        image : workspace.image,
        color: workspace.color
      }).subscribe({next:(workspace:WorkSpaceDto)=>{

        let index = -1;
        if(edit)
        {
          //index = this.workspaces.findIndex(t=>t.id==workspace.id);
          this.getCurrentWorkspace().name = workspace.name;
          this.getCurrentWorkspace().description = workspace.description;
          this.getCurrentWorkspace().image = workspace.image;    
          this.getCurrentWorkspace().secureImage = workspace.secureImage;           
          this.getCurrentWorkspace().color = workspace.color; 
        }
        else
        {            
          this.workspaces.push(workspace);          
          index =  this.getCurrentWorkspaces().length-1;
          this.setCurrentWorkspace(this.getCurrentWorkspaces()[index]); 
        }        
       
        resolve(workspace);

      },error(error:any){
        reject(error);
      }})
    });
  }

  saveNotebook(book:NotebookDto, edit:boolean):Promise<NotebookDto>
  {      
    const _id:string = edit?book.id:"00000000-0000-0000-0000-000000000000";

    return new Promise<NotebookDto>((resolve, reject) => {

      this.addBook({
        workspaceId: this.getCurrentWorkspace()?.id,
        icon: book.icon,
        userId: this.auth.meData?.studiaUserId,
        categoryId: book.categoryId,
        id:  _id,  
        description: book.description,        
        name: book.name,
        tabs:[],
        createDt: book.createDt,
        updateDt: book.updateDt,
        image : book.image
    }).subscribe({next:(notebook:NotebookDto)=>{

      let index = -1;
      if(edit)
      {
        index = this.getCurrentWorkspace().books.findIndex(t=>t.id==book.id);
        
        this.getCurrentWorkspace().books[index].name = notebook.name;
        this.getCurrentWorkspace().books[index].icon = notebook.icon;
        this.getCurrentWorkspace().books[index].description = notebook.description;
        this.getCurrentWorkspace().books[index].categoryId = notebook.categoryId;
        this.getCurrentWorkspace().books[index].categoryName = notebook.categoryName;
        this.getCurrentWorkspace().books[index].subcategoryName = notebook.subcategoryName;
        this.getCurrentWorkspace().books[index].image = notebook.image;         
        this.getCurrentWorkspace().books[index].secureImage = notebook.secureImage;         
        this.getCurrentWorkspace().books[index].updateDt = notebook.updateDt;
      }
      else
      {
        this.getCurrentWorkspace().books.push(notebook);
        index =  this.getCurrentWorkspace().books.length-1;
        this.setCurrentNotebook(this.getCurrentWorkspace().books[index]);
      }        
      
      resolve(notebook);

    },error(error:any){
      reject(error);
    }})

     
    });
  }

  saveTab(tab:TabDto, edit: boolean):Promise<TabDto>{

    const _id:string = edit?tab.id:"00000000-0000-0000-0000-000000000000";

    return new Promise<TabDto>((resolve, reject)=>{
      this.addTab({
        id:  _id,
        color: tab.color,          
        name: tab.name,
        bookId: this.getCurrentNotebook().id,
        code:"TB0001",
        icon:tab.icon,
        contents:[],
        userId: this.auth.meData?.studiaUserId,
        createDt: new Date()
      }).subscribe({next:(tab:TabDto)=>{

        if(edit)
        {
          const index = this.getCurrentNotebook().tabs.findIndex(t=>t.id==tab.id);
          this.getCurrentNotebook().tabs[index].name = tab.name;
          this.getCurrentNotebook().tabs[index].color = tab.color;            
        }
        else
        {
          this.getCurrentNotebook().tabs.push(tab);            
        }
        
        this.getCurrentNotebook().numTabs = this.getCurrentNotebook().tabs.length;
        resolve(tab);

      },error(error){
        reject(error);
      }})     
    })
  }

  // const data = {bookId:result.bookSelected.id, tabId: result.tabSelected.id, title: result.title, extractionFileId: extraction.fileId};
  //   this.dashboardService.createCardFromExtraction(data).subscribe((resultCard:any)=>{console.log(resultCard);});

  saveExtractionToCard(extraction:any):Promise<ContentDto>{

    //const _id:string = edit?tab.id:"00000000-0000-0000-0000-000000000000";
    const data = extraction;
    return new Promise<ContentDto>((resolve, reject)=>{
      this.createCardFromExtraction(data).subscribe({next:(content:ContentDto)=>{

        this.getCurrentWorkspace().books.find(b=>b.id==extraction.bookId)?.tabs.find(t=>t.id==extraction.tabId)?.contents.push(content);
        //  this.getCurrentNotebook().tabs.push(tab);
       
        
        resolve(content);

      },error(){
        reject();
      }})     
    })
  }

  removeTab(tab:TabDto):Promise<boolean>{

     return new Promise<boolean>((resolve, reject)=>{
      this.deleteTab(tab.id).subscribe({next:(result:boolean)=>{

        if(result)
        {
          const bk = this.getCurrentNotebooks().find(b=>b.id==tab.bookId);
          //var ws = this.workspaces.find(w=>w.id==bk?.workspaceId);
          console.log("WORK", bk);
          if(bk!=null)
          {
            //var book = ws.books.find(b=>b.id==tab.bookId);
          
            var tabObj = bk!.tabs.find(t=>t.id==tab.id);
            if(tabObj)
            { var index = bk!.tabs.indexOf(tabObj);
       
              if(index!=undefined && index!=-1)
              bk!.tabs.splice(index, 1);

              bk!.numTabs = bk!.tabs.length;
            }
          }
        }

        resolve(result);

      },error(){
        reject();
      }})     
    })
  }

  removeBook(book:NotebookDto):Promise<boolean>{

    return new Promise<boolean>((resolve, reject)=>{
     this.deleteBook(book.id).subscribe({next:(result:boolean)=>{

       if(result)
       {
        if(book!=undefined && book!=null)
          {
            const ws = this.workspaces.find(w=>w.books.find(b=>b.id==book.id));

            var bookObj = ws?.books.find(t=>t.id==book.id);
           if(bookObj)
           var index = ws?.books.indexOf(bookObj);
      
           if(index)
            ws?.books.splice(index, 1);

          }                                
       }

       resolve(result);

     },error(){
       reject();
     }})     
   })
 }

 unsubscribeBookConfirm(id:string):Promise<boolean>{

  return new Promise<boolean>((resolve, reject)=>{

    this.unsubscribeUserToBook(id).subscribe((unsubscribeResult:boolean)=>{
      if(unsubscribeResult)
      {
        const _book = this.getCurrentSubscribeBooks().find((b:NotebookDto)=>b.library!.id==id)
        const _indexBook = this.getCurrentSubscribeBooks().indexOf(_book!);
        this.getCurrentSubscribeBooks().splice(_indexBook, 1);  
        resolve(true);
      }
      resolve(false);
    }, (err:any)=> {
      resolve(false);
    });               
 })
}

subscribeBookConfirm(id:string):Promise<any>{

  return new Promise<any>((resolve, reject)=>{

    this.subscribeUserToBook(id).subscribe((subscriptionResult:any)=>{    
      this.getCurrentSubscribeBooks().push(subscriptionResult);     
      resolve(subscriptionResult);
    }, (err:any)=>{resolve(null);});      
 })
}

 removeFile(file:any):Promise<boolean>{

  return new Promise<boolean>((resolve, reject)=>{
   this.deleteFile(file).subscribe({next:(result:boolean)=>{

     resolve(result);

   },error(){
     reject();
   }})     
 })
};

removeFiles(files:any[]):Promise<boolean>{

  return new Promise<boolean>((resolve, reject)=>{
   this.deleteFiles(files).subscribe({next:(result:boolean)=>{

     resolve(result);

   },error(){
     reject();
   }})     
 })
};


saveCard(content: ContentDto, tab: TabDto, edit: boolean):Promise<ContentDto>
{
 
  return new Promise<ContentDto>((resolve, reject)=>{
    this.addContent(content).subscribe({next:(result: ContentDto)=>{

     
      if(edit)
      {
        // book.tabs.find((t:TabDto)=>t.id==tab.id).contents.find((c:ContentDto)=>c.id == content.id)
      }
      else{
        tab.contents.push(result);
        let numCards=0;
        this.getCurrentNotebooks().find(n=>n.id==tab.bookId)?.tabs.forEach(t=>numCards+=t.contents.length);
        this.getCurrentNotebooks().find(n=>n.id==tab.bookId)!.numCards = numCards;
      }
     

      resolve(result);
    }, error(error:any){
      reject(error);
    }})
  });
}

saveLinkFileCard(file: any, tab: TabDto, edit: boolean):Promise<ContentDto>
{
 
  let content:ContentDto = {
    id: "00000000-0000-0000-0000-000000000000",
    value:"", 
    label: "", 
    createDt: new Date(), 
    editmode:false, 
    expanded: true, 
    updateDt: new Date(),
    tabId: tab.id,
    type:"LINKFILE",        
    bookId: tab.bookId,
    fileLink: {fileId: file.id, fileName: file.fileName, fileExtension: file.extension, folder: "", sizeInBytes: file.sizeInBytes}
  };

  return new Promise<ContentDto>((resolve, reject)=>{
    this.addLinkFile(content).subscribe({next:(result: ContentDto)=>{

     
     
        tab.contents.push(result);
        let numCards=0;
        this.getCurrentNotebooks().find(n=>n.id==tab.bookId)?.tabs.forEach(t=>numCards+=t.contents.length);
        this.getCurrentNotebooks().find(n=>n.id==tab.bookId)!.numCards = numCards;
     
     

      resolve(result);
    }, error(error:any){
      reject(error);
    }})
  });
}

 saveFolder(folder:FolderDto, edit: boolean):Promise<FolderDto>{

  const _id:string = edit?folder.id:"00000000-0000-0000-0000-000000000000";
  return new Promise<FolderDto>((resolve, reject)=>{
    this.addUpdateFolder({
      id:  _id,
      parentId: folder.parentId,
      name: folder.name,
      workspaceId: this.getCurrentWorkspace().id,                    
      createDt: new Date()
    }).subscribe({next:(_folder:FolderDto)=>{        
      resolve(_folder);
    },error(){
      reject();
    }})     
  })
}

  saveAssistant(assistant:AssistantDto, edit: boolean):Promise<AssistantDto>{

    const _id:string = edit?assistant.id:"00000000-0000-0000-0000-000000000000";

    return new Promise<AssistantDto>((resolve, reject)=>{
      this.addAssistant({
        id:  _id,
        image: assistant.image,
        name: assistant.name,
        workspaceId: this.getCurrentWorkspace().id,                    
        userId: this.auth.meData?.studiaUserId,
        htmlResponseConfig: assistant.htmlResponseConfig,
        longResponseConfig: assistant.longResponseConfig,
        toneResponseConfig:assistant.toneResponseConfig,
        useEmojiConfig: assistant.useEmojiConfig,
        voiceActive: assistant.voiceActive,
        model:assistant.model,
        instructions: assistant.instructions,
        createDt: new Date()
      }).subscribe({next:(_assistant:AssistantDto)=>{

        //console.log(this.getAssistants());
        // var _assistantChanged = this.assistants.find(a=>a.id==_assistant.id);
        // if(_assistantChanged!=undefined && _assistant!=null)
        //   _assistantChanged = _assistant;

        // console.log(this.getAssistants());

        resolve(_assistant);

      },error(){
        reject();
      }})     
    })
  }

  registerJob(job:JobDto) : Promise<ContentDto>
  {
    
    return new Promise<ContentDto>((resolve, reject)=>{
      this.addJob(job).subscribe({next:(content:ContentDto)=>{

        this.pendingJobs.push({id: content.jobId??'', status: content.status, instructions: content.label, type: content.type});
        resolve(content);

      },error(){
        reject();
      }})     
    })
  }

  saveThread(thread:ThreadDto, edit: boolean):Promise<ThreadDto>{

    const _id:string = edit?thread.id:"00000000-0000-0000-0000-000000000000";

    return new Promise<ThreadDto>((resolve, reject)=>{
      this.addThread({
        id:  _id,          
        name: thread.name,
        workspaceId: this.getCurrentWorkspace().id,                    
        bookId: thread.bookId,
        code: '',         
        createDt: new Date()
      }).subscribe({next:(_thread:ThreadDto)=>{

        this.workspaces.find(w=>thread.workspaceId!)?.threads!.push(_thread);
        resolve(_thread);

      },error(){
        reject();
      }})     
    })
  }




  saveAddBookToLibrary(isEdition: boolean, bookLibrary: LibraryBookDto):Promise<LibraryBookDto>{

    const _id:string = isEdition?bookLibrary.id:"00000000-0000-0000-0000-000000000000";

    return new Promise<LibraryBookDto>((resolve, reject)=>{
      this.addBookToLibrary(bookLibrary).subscribe({next:(book:LibraryBookDto)=>{
        
        resolve(book);

      },error(){
        reject();
      }})     
    })
  }

}